// const baseUrl = 'http://192.168.50.253:8080';
// http://86.125.33.141:8080
// const baseUrl = 'http://localhost:8080';
const baseUrl = '/api';

export const signupUrl = `${baseUrl}/signup`;
export const loginUrl = `${baseUrl}/login`;
export const usersUrl = `${baseUrl}/users`;
export const projectsUrl = `${baseUrl}/projects`;
export const materialsUrl = `${baseUrl}/materials`;
export const clientsUrl = `${baseUrl}/clients`;
export const activitiesUrl = `${baseUrl}/activities`;
export const employeesUrl = `${baseUrl}/employees`;